import { useState, useRef, useEffect } from "react";
import Icon from "./Icon.jsx";
import { useAuth } from "../context/AuthContext.jsx";

export default function TopBar({ state, onHome, showBackTo }) {
  return (
    <div className="topbar">
      <div
        className="logo"
        onClick={onHome}
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onHome?.()}
      >
        <span className="logo-mark terra">L</span>
        <span>LearnClaude</span>
      </div>

      {showBackTo && (
        <button
          className="btn btn-ghost"
          style={{ padding: "8px 14px", fontSize: 13 }}
          onClick={showBackTo.onClick}
        >
          <Icon name="arrow-left" size={14} /> {showBackTo.label}
        </button>
      )}

      <div className="top-stats">
        <Stat icon="flame" value={state.streak} label="day streak" />
        <Stat icon="gem" value={state.gems} label="gems" />
        <Stat icon="bolt" value={`Lvl ${state.level}`} label={`${state.xp} XP`} />
        <Hearts count={state.hearts} />
        <UserMenu />
      </div>
    </div>
  );
}

function Stat({ icon, value, label }) {
  return (
    <div className="stat" title={label}>
      <Icon name={icon} size={15} />
      <span className="val">{value}</span>
    </div>
  );
}

function Hearts({ count, max = 5 }) {
  return (
    <div className="stat" title={`${count} hearts`} style={{ gap: 4 }}>
      {Array.from({ length: max }).map((_, i) => (
        <span key={i} style={{ opacity: i < count ? 1 : 0.2, transition: "opacity 200ms" }}>
          <Icon name="heart" size={14} />
        </span>
      ))}
    </div>
  );
}

function UserMenu() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  if (!user) return null;

  const initial = (user.name || user.email || "L").trim().charAt(0).toUpperCase();

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        className="avatar-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="User menu"
        aria-expanded={open}
      >
        {user.picture ? (
          <img src={user.picture} alt="" referrerPolicy="no-referrer" />
        ) : (
          <span className="avatar-fallback">{initial}</span>
        )}
        <span style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {user.name.split(" ")[0]}
        </span>
      </button>

      {open && (
        <div className="user-menu" role="menu">
          <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--line)", marginBottom: 4 }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{user.name}</div>
            {user.email && (
              <div style={{ fontSize: 12, color: "var(--ink-3)" }}>{user.email}</div>
            )}
            <div className="eyebrow" style={{ marginTop: 4 }}>via {user.provider}</div>
          </div>
          <button className="user-menu-item" onClick={signOut} role="menuitem">
            <Icon name="logout" size={14} /> Sign out
          </button>
        </div>
      )}
    </div>
  );
}
